import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errorMessage } from "@/lib/api";
import { AuthShell, FormError } from "@/components/auth/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Esqueci minha senha" subtitle="Enviamos um link para você criar uma nova senha." testid="forgot-page">
      {sent ? (
        <div className="space-y-4" data-testid="forgot-sent">
          <div className="flex gap-3 rounded-lg border border-emerald-500/40 bg-emerald-500/10 p-3 text-sm text-emerald-200">
            <MailCheck className="h-5 w-5 shrink-0" />
            <p>Se existir uma conta com <b>{email}</b>, você vai receber o link em alguns minutos. Confira também a caixa de spam. O link vale por 1 hora.</p>
          </div>
          <Button asChild variant="outline" className="w-full rounded-full border-slate-700 bg-transparent"><Link to="/login" data-testid="forgot-back-login">Voltar para o login</Link></Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-1.5">
            <Label htmlFor="fp_email">E-mail da conta</Label>
            <Input id="fp_email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 bg-slate-950" data-testid="forgot-email-input" />
          </div>
          <FormError error={error} />
          <Button type="submit" disabled={loading} className="h-11 w-full rounded-full font-semibold" data-testid="forgot-submit-button">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Enviar link
          </Button>
          <p className="text-center text-sm"><Link to="/login" className="text-slate-400 underline" data-testid="forgot-login-link">Voltar para o login</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
